import React from "react";

import "./TestIndicator.css";

const TestIndicator = () => {
  return (
    <div id="test-indicator">
      <span id="test-indicator-text">test page</span>
    </div>
  );
};

export default TestIndicator;
